export default "__VITE_ASSET__FBIGIwRb__"